module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Horn-da648f8a64246e2222b93bc8dee6ccf5.svg";